// Function to encrypt and save salt to localStorage
export function obfuscateString(str) {
  const salt = Math.random().toString(36).substring(2, 10);
  localStorage.setItem('ds', salt);
  
  const saltedStr = salt + str;
  const reversedStr = saltedStr.split('').reverse().join('');
  
  return btoa(reversedStr);
}

// Function to decrypt using salt from localStorage
export function deobfuscateString(encodedStr) {
  const salt = localStorage.getItem('ds');
  if (!salt) {
    console.error("No decryption salt found in localStorage.");
    return null;
  }
  
  const decodedStr = atob(encodedStr);
  const saltedOriginalStr = decodedStr.split('').reverse().join('');
  
  // The length of the salt is now dynamically determined
  const originalStr = saltedOriginalStr.substring(salt.length);
  
  return originalStr;
}